module.exports =
{
    ADDRESS: "http://79.143.190.57:3000/api/v1/",
  //  ADDRESS: "http://78.46.11.36:3000/api/v1/",
     
}